import React from 'react';

const STATS = [
    { tone: 'yellow', value: '6–8 wks', label: 'Average seed due diligence, unprepared' },
    { tone: 'green', value: '2–4 wks', label: 'Same round, fully prepared' },
    { tone: 'coral', value: '15–20', label: 'Issues an AI reviewer finds, vs. 5 for a human' },
    { tone: 'indigo', value: '<1%', label: 'Of pitched companies get funded at all' },
];

const AccMarketContextSection = () => (
    <section className="lp-acc-sec">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>Our Experience</span>
            <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">Your cohort is about to face a different kind of investor diligence.</h2>
            <p className="lp-acc-sub" data-lp-reveal data-lp-delay="120">Your programme does the hard work: validating the model, sharpening the pitch, connecting founders to mentors. But your companies still arrive at demo day with a deck and optimism — not a structured evidence base. Meanwhile, VCs are moving AI diligence tools from experiment to standard practice, and AI does not miss what a tired human reviewer might. Companies that arrive unprepared don't lose the deal at the pitch. They lose it three weeks into diligence, one gap at a time.</p>
            <div className="lp-acc-pullquote" data-lp-reveal data-lp-delay="160">"A folder of unorganised PDFs is not a data room. It is an invitation for extended enquiry."</div>
            <div className="lp-acc-stat-row">
                {STATS.map((s, i) => (
                    <div className={`lp-acc-fstat is-${s.tone}`} key={s.label} data-lp-reveal data-lp-delay={i * 80}>
                        <div className="lp-acc-circle">{s.value}</div>
                        <div className="flabel">{s.label}</div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default AccMarketContextSection;
